import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EDITOR_TYPE } from '../messageCreators';
import { fetchSites } from '../thunks/sites.thunk';

export interface ISiteItem {
  id: string;
  name: string;
  premium: boolean;
  published: boolean;
  thumbnail: string;
  updatedAt: string;
  url: string;
  userRole: string;
  editorType: EDITOR_TYPE;
}

interface SitesState {
  sites: ISiteItem[];
  selectedSite: ISiteItem | null;
  isLoading: boolean;
  hasError: boolean;
  hasFetched: boolean;
}

const initialState: SitesState = {
  sites: [],
  selectedSite: null,
  isLoading: false,
  hasError: false,
  hasFetched: false,
};

export const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    selectSite: (state, action: PayloadAction<ISiteItem>) => {
      state.selectedSite = action.payload;
    },
    clearSelection: (state) => {
      state.selectedSite = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSites.pending, (state) => {
      state.isLoading = true;
      state.hasError = false;
    });
    builder.addCase(fetchSites.fulfilled, (state, action) => {
      state.sites = action.payload.sites;
      state.selectedSite = action.payload.selectedSite;
      state.isLoading = false;
      state.hasFetched = true;
    });
    builder.addCase(fetchSites.rejected, (state) => {
      state.isLoading = false;
      state.hasError = true;
      state.hasFetched = true;
    });
  },
});
